import(/* webpackMode: "eager", webpackExports: ["SplashScreen"] */ "/app/apps/web/src/components/loading-screen/splash-screen.tsx");
